
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import { TableCellComputed, TableCellData, TableCellMethods, TableCellProps } from './TableCell';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import { mountFootnotes } from '@owc-utils/Footnotes/FootnotesHelper';
import { isMobileLayout } from './TableUtils';

export default ComponentInitializeDispatcher.extend<
  TableCellData,
  TableCellMethods,
  TableCellComputed,
  TableCellProps
>({
  name: 'owc-table-cell',
  components: {
    ValidationBoxWrapper,
  },
  mixins: [OwcDataComponent],
  computed: {
    label: function() {
      return this.componentData?.label;
    },
    value: function() {
      return this.componentData?.value;
    },
    tooltip: function() {
      return this.componentData?.tooltip;
    },
    hasTooltip: function() {
      return Boolean(this.componentData?.tooltip);
    },
    efficiency: function() {
      return this.componentData?.efficiency;
    },
    hasEfficiency: function() {
      return Boolean(this.componentData?.efficiency);
    },
    isInModal: function() {
      return Boolean(this.componentData?.isInModal && isMobileLayout);
    },
  },
  watch: {
    isInModal: {
      handler(newValue: boolean, oldValue: boolean) {
        if (newValue !== oldValue && oldValue !== undefined) {
          if (this.$el.querySelector('[data-footnote-id]')) {
            mountFootnotes(this, newValue);
          }
        }
      },
    },
  },
});
